var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.nextEnvironment)?_c('alert',{attrs:{"message":`The following changes will not be published to ${_vm.nextEnvironment}.`,"type":"warning","inline":""}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }